import fileDownload from 'js-file-download';
import { BACKEND_URL_PREFIX, itemsPerPage } from '../utils/const';
import {
  THEMATIC_PLANNING_SET_FILTERS,
  THEMATIC_PLANNING_FETCH_STARTED,
  THEMATIC_PLANNING_FETCH_COMPLETED,
  THEMATIC_PLANNING_FETCH_FAILED,
  THEMATIC_PLANNING_TREE_FETCH_STARTED,
  THEMATIC_PLANNING_TREE_FETCH_COMPLETED,
  THEMATIC_PLANNING_TREE_FETCH_FAILED,
  THEMATIC_PLANNING_TREE_CLEAR,
  THEMATIC_PLANNING_LESSON_FETCH_STARTED,
  THEMATIC_PLANNING_LESSON_FETCH_COMPLETED,
  THEMATIC_PLANNING_LESSON_FETCH_FAILED,
  THEMATIC_PLANNING_LESSON_CLEAR,
} from './types';
import { buildDefaultHeaders } from './helper';
import { checkAndUpdateToken } from './auth';
import { createNotification } from '../components/notifications/notifications';

export const setThematicPlanningFilters = (filters) => ({ type: THEMATIC_PLANNING_SET_FILTERS, filters });

export const fetchThematicPlanning = ({ syid = 0, idcurriculum = 0, cid = 0, page = 0 } = {}) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: THEMATIC_PLANNING_FETCH_STARTED });

  const limit = itemsPerPage;
  const offset = page * limit;
  const params = new URLSearchParams({ syid, idcurriculum, cid, limit, offset });

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/thematic_planning?${params.toString()}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const result = await response.json();
    dispatch({
      type: THEMATIC_PLANNING_FETCH_COMPLETED,
      list: result.thematic_planning || [],
      count: result.count || 0,
    });
  } else {
    dispatch({ type: THEMATIC_PLANNING_FETCH_FAILED, status: response.status });
  }
};

export const fetchThematicPlanningTree = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: THEMATIC_PLANNING_TREE_FETCH_STARTED });

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/thematic_planning/${id}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const result = await response.json();
    dispatch({ type: THEMATIC_PLANNING_TREE_FETCH_COMPLETED, data: result });
  } else {
    dispatch({ type: THEMATIC_PLANNING_TREE_FETCH_FAILED, status: response.status });
  }
};

export const clearThematicPlanningTree = () => ({ type: THEMATIC_PLANNING_TREE_CLEAR });

// Сведения о занятии тематического плана — режим только на чтение (HLMS-7600/7602,
// «Тематические планы: сведения о занятии и файлы»). lessonId — course_tema_detail.id,
// он же приходит числом в id узла типа lesson_plan дерева плана.
export const fetchThematicPlanningLesson = (lessonId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: THEMATIC_PLANNING_LESSON_FETCH_STARTED });

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/thematic_planning/lesson/${lessonId}`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const result = await response.json();
    dispatch({ type: THEMATIC_PLANNING_LESSON_FETCH_COMPLETED, data: result });
  } else {
    dispatch({ type: THEMATIC_PLANNING_LESSON_FETCH_FAILED, status: response.status });
  }
};

export const clearThematicPlanningLesson = () => ({ type: THEMATIC_PLANNING_LESSON_CLEAR });

// Файл занятия отдаётся application/octet-stream с типом содержимого по расширению.
// mode: 'download' — сохранить на компьютер, 'view' — открыть на просмотр в новой вкладке.
// Запрос идёт с BasicAuth, поэтому простой <a target="_blank"> не годится: тянем blob сами.
export const openThematicPlanningLessonFile = (lessonId, fileId, { name = 'file', mode = 'download' } = {}) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  const response = await fetch(
    `${BACKEND_URL_PREFIX}/thematic_planning/lesson/${lessonId}/files/${fileId}`,
    buildDefaultHeaders(getState)
  );

  if (!response.ok) {
    createNotification('error', 'Не удалось получить файл занятия', 'Ошибка');
    return;
  }

  const blob = await response.blob();

  if (mode === 'view') {
    const url = window.URL.createObjectURL(blob);
    const win = window.open(url, '_blank', 'noopener');
    // вкладка могла не открыться (блокировщик) — тогда хотя бы сохраняем
    if (!win) fileDownload(blob, name);
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  } else {
    fileDownload(blob, name);
  }
};
